"use client"

import type React from "react"

interface AssessmentOptionProps {
  label: string
  value: string
  isSelected: boolean
  isAnimating: boolean
  onClick: (value: string) => void
}

export const AssessmentOption: React.FC<AssessmentOptionProps> = ({
  label,
  value,
  isSelected,
  isAnimating,
  onClick,
}) => {
  return (
    <button
      className={`w-full p-5 rounded-xl text-left transition-all duration-300 border-2 font-medium ${
        isSelected
          ? "border-indigo-500 bg-indigo-50 shadow-lg scale-105 ring-2 ring-indigo-300 text-slate-900"
          : "border-slate-200 bg-white hover:border-teal-400 hover:shadow-md hover:bg-teal-50 text-slate-700"
      }`}
      onClick={() => onClick(value)}
      disabled={isAnimating}
    >
      {label}
    </button>
  )
}
